import React, { useEffect } from 'react'
import { Container, Row, Col } from 'components/Grid'

const GREENHOUSE_BOARD = process.env.GATSBY_GREENHOUSE_BOARD_TOKEN

function Application({ blok }) {
  useEffect(() => {
    const script = document.createElement('script')

    script.src = `https://boards.greenhouse.io/embed/job_board/js?for=${GREENHOUSE_BOARD}`
    script.onload = () => {
      window.Grnhse.Iframe.load(blok.gh_Id)
    }

    document.body.appendChild(script)
  })

  return (
    <Container css="height: max-content;">
      <Row justifyContent="center">
        <Col width={[1, 1, 10 / 12]}>
          <div id="grnhse_app" style={{ minHeight: '600px' }} />
        </Col>
      </Row>
    </Container>
  )
}

export default React.memo(Application)
